// Утилиты для работы с согласием на куки

export type CookieConsentStatus = 'accepted' | 'declined' | null;

/**
 * Получить статус согласия на куки
 */
export const getCookieConsent = (): CookieConsentStatus => {
  if (typeof window === 'undefined') return null;
  
  const consent = localStorage.getItem('cookie-consent');
  return consent as CookieConsentStatus;
};

/**
 * Проверить, дал ли пользователь согласие на куки
 */
export const isCookieConsentAccepted = (): boolean => {
  return getCookieConsent() === 'accepted';
};

/**
 * Проверить, отклонил ли пользователь куки
 */
export const isCookieConsentDeclined = (): boolean => {
  return getCookieConsent() === 'declined';
};

/**
 * Проверить, нужно ли показывать баннер согласия
 */
export const shouldShowCookieBanner = (): boolean => {
  return getCookieConsent() === null;
};

/**
 * Получить дату согласия/отклонения
 */
export const getCookieConsentDate = (): Date | null => {
  if (typeof window === 'undefined') return null;
  
  const dateString = localStorage.getItem('cookie-consent-date');
  return dateString ? new Date(dateString) : null;
};

/**
 * Проверить, можно ли использовать аналитику
 */
export const canUseAnalytics = (): boolean => {
  return isCookieConsentAccepted();
};

/**
 * Инициализация аналитики только при согласии
 */
export const initAnalyticsIfAllowed = async () => {
  if (!canUseAnalytics()) {
    console.log('🚫 Аналитика заблокирована - нет согласия пользователя');
    return;
  }

  console.log('✅ Инициализация аналитики разрешена');
  
  try {
    // Google Analytics
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted'
      });
    }

    // Яндекс.Метрика - динамический импорт для избежания циклических зависимостей
    const { initYandexMetrika } = await import('../services/yandexMetrika');
    await initYandexMetrika();
    
  } catch (error) {
    console.error('Ошибка инициализации аналитики:', error);
  }
};

/**
 * Сброс согласия на куки (для тестирования)
 */
export const resetCookieConsent = () => {
  if (typeof window === 'undefined') return;
  
  localStorage.removeItem('cookie-consent');
  localStorage.removeItem('cookie-consent-date');
  console.log('🔄 Согласие на куки сброшено');
};
